// extracted by mini-css-extract-plugin
export default {"resolution":"ResultTile_resolution__UZDeu","graphWrapper":"ResultTile_graphWrapper__+k5IB"};